import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/workflow/importer/workflowImporterActions';

export default importerReducers(actions);
